import {
    OUTLOOK_DESKTOP,
    MAC_OUTLOOK,
    IOS_OUTLOOK,
    ANDROID_OUTLOOK,
    NATIVE,
    TEAMS,
    O365_SHELL,
} from 'owa-config';

// Very often we want to enable/disable a flag for all OPX scenarios at the same time.
// In order to not define a value for each OPX type we can use 'opx' fallback.
// In this case we are able to simplify a config, but still keep flexibility to define different values for each OPX type separately.
const OPX = 'opx';

export type HOST_APP_TYPES =
    | typeof OUTLOOK_DESKTOP
    | typeof MAC_OUTLOOK
    | typeof IOS_OUTLOOK
    | typeof ANDROID_OUTLOOK
    | typeof NATIVE
    | typeof TEAMS
    | typeof O365_SHELL
    | typeof OPX;

export type HOST_APP_FLAG = { default: boolean } & { [key in HOST_APP_TYPES]?: boolean };

const flags: { [key: string]: HOST_APP_FLAG } = {
    showOwaBranding: {
        default: true,
        native: false,
    },
    includePartnerIn3SRequest: {
        default: false,
        native: true,
    },
    loadThemeFromHostApp: {
        default: false,
        opx: true,
    },
    opxDeeplink: {
        default: false,
        opx: true,
    },
    authRedirectOnSessionTimeout: {
        default: true,
        native: false,
        opx: false,
    },
    opxComponentLifecycle: {
        default: false,
        opx: true,
    },
    surfaceJoin: {
        default: false,
        teams: true,
    },
    opxReadingPaneActions: {
        default: false,
        opx: true,
    },
    readingPaneModal: {
        default: true,
        teams: false,
    },
    readingPaneHeaderTitleAndJoinLink: {
        default: true,
        teams: false,
    },
    opxComposeForm: {
        default: false,
        teams: true,
    },
    opxServiceWorker: {
        default: false,
        opx: true,
    },
    opxStaticUrl: {
        default: false,
        opx: true,
    },
    opxAddCalendar: {
        default: false,
        opx: true,
    },
    teamsChannelOptions: {
        default: false,
        teams: true,
    },
    liveNotifications: {
        default: false,
        macoutlook: true,
    },
    teamsCalendarPicker: {
        default: false,
        teams: true,
    },
    joinTeamsMeeting: {
        default: false,
        opx: true,
    },
    calendarPaneHeaderWeather: {
        default: true,
        teams: false,
    },
    use3SPeopleSuggestions: {
        default: true,
        macoutlook: false,
    },
    joinButtonInSurfaceEvents: {
        default: false,
        teams: true,
    },
    defaultCalendarColor: {
        default: false,
        opx: true,
    },
    opxRoomSelection: {
        default: false,
        opx: true,
    },
    opxInboxRules: {
        default: false,
        opx: true,
    },
    moduleNameFromWindow: {
        default: true,
        opx: false,
    },
    showArchiveUnreadCount: {
        default: false,
        native: true,
    },
};

export const getFlagDefaults = (flagName: string) => {
    return flags[flagName];
};
